import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45ca3f82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footerDiv" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))

import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FootContent',
  setup(__props) {

const A = ref(0);
const B = ref(0);
const C = ref(0);
const D = ref(0);

const show_runtime = () => {
  var X = new Date("3/16/2024 15:44:45");
  var Y = new Date();
  var T = Y.getTime() - X.getTime();
  var M = 24 * 60 * 60 * 1000;
  var a = T / M;
  A.value = Math.floor(a);
  var b = (a - A.value) * 24;
  B.value = Math.floor(b);
  var c = (b - B.value) * 60;
  C.value = Math.floor((b - B.value) * 60);
  D.value = Math.floor((c - C.value) * 60);
};
onMounted(() => {
  let timer = setInterval(() => {
    show_runtime();
  }, 1000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("menus.home.run")) + " " + _toDisplayString(A.value) + _toDisplayString(_ctx.$t("menus.home.day")) + _toDisplayString(B.value) + _toDisplayString(_ctx.$t("menus.home.hour")) + _toDisplayString(C.value) + _toDisplayString(_ctx.$t("menus.home.minutes")) + _toDisplayString(D.value) + _toDisplayString(_ctx.$t("menus.home.second")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("menus.home.footComment")), 1),
      _hoisted_3
    ])
  ]))
}
}

})